var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 0C24.0514 0 27.3346 3.33333 27.3346 8C27.3346 17.3333 17.3346 22.6667 14.0013 24.6667C10.668 22.6667 0.667969 17.3333 0.667969 8C0.667969 3.33333 4.0013 0 8.0013 0C10.4813 0 12.668 1.33333 14.0013 2.66667C15.3346 1.33333 17.5213 0 20.0013 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.6a6c219e9e8214446ddd6d15194604bc.svg";
export { ForwardRef as ReactComponent };